import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import { tabsSliderOptions, tabsContentSliderOptions, innerSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'st';

  const crmIntegrationTabsSlider = initSlider('[data-crm-integration-tabs-slider]', tabsSliderOptions);
  const crmIntegrationSlider = initSlider('[data-crm-integration-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: crmIntegrationTabsSlider,
      autoScrollOffset: 0.5,
    },
    allowTouchMove: false,
  });

  /*  */

  const innerSliders = initSlider('[data-inner-slider]', innerSliderOptions);
  innerSliders.forEach((slider) => {
    slider.on('slideChangeTransitionStart', (swiper) => changeActiveSlide(swiper, PAGE));
  });

  /*  */

  crmIntegrationTabsSlider.on('click', (swiper) => {
    // innerSliders.forEach(swiper => swiper.slideTo(0));
    changeActiveSlide(swiper, PAGE);
  });
  // crmIntegrationSlider.on("slideChangeTransitionStart", (swiper) => {
  //  changeActiveSlide(swiper, PAGE);
  // });
});
